import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { TaskInternalPartnerFileInterface } from "./definitions/task-internal-partner-file-interface";
import { Observable } from "rxjs";
import { ErrorsInterface } from "../errors/errors-interface";
import uploadInternalPartnerTaskFileMutation from "./mutations/upload";
import taskByIdQuery from "../tasks/queries/task-by-id";
import { FetchResult } from '@apollo/client/core';

interface InternalPartnerFileUploadResponse {
  taskInternalPartnerFile: {
    upload: {
      output: TaskInternalPartnerFileInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class UploadInternalPartnerTaskFileService {
  constructor(private apollo: Apollo) {}

  uploadFile(
    taskId: string,
    name: string,
    content: string,
    extension: string,
    customPlaceHolderId?: string
  ): Observable<FetchResult<InternalPartnerFileUploadResponse>> {
    return this.apollo.mutate<InternalPartnerFileUploadResponse>({
      mutation: uploadInternalPartnerTaskFileMutation,
      variables: {
        taskId: taskId,
        name: name,
        content: btoa(content),
        extension: extension,
      },
      optimisticResponse: {
        taskInternalPartnerFile: {
          upload: {
            output: {
              id: customPlaceHolderId
                ? customPlaceHolderId
                : '-' + Math.random(),
              size: 0,
              createdAt: new Date(),
              updatedAt: new Date(),
              removedAt: null,
              type: null,
              src: null,
              thumbnails: [],
              taskId: taskId,
              name: name,
              extension: extension,
            },
            errors: {
              errors: [],
              status: 0,
              message: '',
            },
          },
        },
      },
      update: (proxy, mutationResult) => {
        const data = <{ task: any }>(
          proxy.readQuery({ query: taskByIdQuery, variables: { id: taskId } })
        );
        data.task.byId.output.taskInternalPartnerFiles.push(
          mutationResult.data.taskInternalPartnerFile.upload.output
        );
        proxy.writeQuery({
          query: taskByIdQuery,
          variables: { id: taskId },
          data,
        });
      },
    });
  }
}
